

























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
/* import { isFunction } from 'lodash';
import { GridApi } from 'ag-grid-community'; */
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { ConfigEmpresas } from '@/pantallas/SucursalVirtual/MisSolicitudes/fetchConfigInicial';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import {
  Activos,
  fetchActivos,
} from '@/pantallas/SucursalVirtual/NuevaSolicitud/fetchActivos';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class FiltrosBusqueda extends Vue {
  @Prop() listaEmpresas: ConfigEmpresas[];
  @Prop() listaEstados: any[];
  @Prop() listaPatentes: any[];
  @Prop() categoriaUsuario: string;
  /* TODO: estas variables solo se utilizan aqui, tal vez no deban ser Properties */
  @Prop({ default: 140390003 }) defaultEstado!: number;
  @Prop({ default: '' }) rutClienteDefecto!: string;
  @Prop({ default: '' }) defaultPatente!: string;

  activos: string[] = [];
  activosSelected: string[] = [];

  formFields: FormFieldDefMap = {
    empresa: {
      label: 'Empresa',
      id: 'empresa',
      value: this.rutClienteDefecto,
    },
    estado: {
      label: 'Estado',
      id: 'estado',
      value: this.defaultEstado,
    },
    patente: {
      label: 'Patente',
      id: 'patente',
      value: '',
      items: [],
    },
    fechaInicio: {
      label: 'Fecha de Inicio del Caso',
      id: 'fechaInicio',
      value: moment().subtract(1, 'month'),
    },
    fechaFin: {
      label: 'Fecha de Fin del Caso',
      id: 'fechaFin',
      value: moment(),
    },
  };

  @Watch('formFields.fechaInicio.value')
  handleStartDate() {
    if (this.formFields.fechaInicio.value > this.formFields.fechaFin.value) {
      this.formFields.fechaFin.value = this.formFields.fechaInicio.value;
    }
  }

  @Watch('formFields.fechaFin.value')
  handleEndDate() {
    if (this.formFields.fechaFin.value < this.formFields.fechaInicio.value) {
      this.formFields.fechaInicio.value = this.formFields.fechaFin.value;
    }
  }

  mounted() {
    this.searchDataEmpresa(this.rutClienteDefecto);
  }

  handleBuscarClick() {
    this.$emit('resultadoBusqueda', this.formFields);
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: {} as any,
    });
  }

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  validateActivosSelected(activo: string) {
    //eslint-disable-next-line
    if (
      !/^([a-zA-Z]{4}\-{1}[0-9]{2})|([a-zA-Z]{2}\-{1}[0-9]{4})$/.test(activo)
    ) {
      this.$snotify.error(
        'La patente ' +
          activo +
          ' no tiene un formato valido (AAAA-00, AA-0000)',
        {
          timeout: 5000,
        }
      );
      return false;
    }
    return true;
  }
  patenteBlur(a: string) {
    if (
      this.formFields.patente.value == '' ||
      this.formFields.patente.value == undefined
    ) {
      console.log('entro patenteBlur if');
      this.formFields.patente.value = a;
    }
    return false;
    // this.activosSelected.forEach(i => {
    //   this.validateActivosSelected(i);
    // });
  }

  fetchDeActivos(cliente: string) {
    this.loadingService.showLoading();
    return fetchActivos(cliente)
      .catch(() => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'los activos',
          })
        );
        return;
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  get fechaMaxima() {
    let fechaMax: any = new Date().toISOString().substr(0, 10);
    console.log(fechaMax);
    return fechaMax;
  }

  get fechaMaximaInicio() {
    //let fechaMax: any = new Date().toISOString().substr(0, 10);
    let fechaMax = this.formFields.fechaHasta.value;
    return fechaMax as moment.Moment;
  }

  get fechaMinimaInicio() {
    //let fechaMax: any = new Date().toISOString().substr(0, 10);
    let fechaIni = this.formFields.fechaDesde.value;
    return fechaIni as moment.Moment;
  }

  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }

  clearFilters() {
    this.formFields.empresa.value = this.rutClienteDefecto;
    this.formFields.estado.value = this.defaultEstado;
    console.log(this.formFields.patente.value);
    this.formFields.patente.value = '';
    console.log(this.formFields.patente.value);
    this.formFields.fechaInicio.value = moment().subtract(1, 'month');
    this.formFields.fechaFin.value = moment();
    this.$emit('clear');
  }

  searchDataEmpresa(a: string) {
    this.searchDataActivos(a);
  }

  async searchDataActivos(cliente: string) {
    this.activos = (await this.fetchActivos(cliente)) || [];
    this.formFields.patente.items = this.activos;
  }

  fetchActivos(cliente: string) {
    this.loadingService.showLoading();
    return fetchActivos(cliente)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'los activos',
          })
        );
        return;
      })
      .finally(() => this.loadingService.hideLoading());
  }

  showFilters: boolean = true;

  showAdvancedFilters: boolean = true;
  AdvancedFilters() {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }
}
